import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { useTheme } from '@material-ui/core/styles'

function ThemeConsumer({ children }) {
    const theme = useTheme()

    return <Fragment>{children(theme)}</Fragment>
}

ThemeConsumer.propTypes = {
    children: PropTypes.func.isRequired
}

export default React.memo(ThemeConsumer)
